var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('navbar'),_c('div',{staticClass:"main-wrapper"},[_c('sidebar',{staticClass:"sidebar-container"}),_c('app-main',{staticClass:"app-main-container"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }